import {mapState, mapMutations} from 'vuex'
import { envMixin } from '../../../assets/js/mixin/global'

export const communityMixin = {
  mixins: [envMixin],
  data() {
    return {
      accountUser: {},
      needShare: ''
    }
  },
  mounted() {
  },
  computed: {
    ...mapState('community', ['newList', 'searchListNews'])
  },
  methods: {
    ...mapMutations('community', ['setRecommendData']),
    changeNeedShareValue() {
      this.needShare = this.$db.ls.get('shareNeed')
      this.$db.ls.remove('shareNeed')
      console.log(this.needShare, 'needShare====>>>')
    },
    _synchronizeStateForList(id, type, total, field, value) {
      const list = JSON.parse(JSON.stringify(this.newList))
      const index = list.findIndex(item => item.id === id)
      if (index > -1) {
        // list[index][type] = total
        // list[index].my_status[field] = value
        // this.setRecommendData({ list })
      }
    },
    // 获取用户账号信息
    async getAccountUser() {
      let res = await this.$api.user.getAccountInfoByAuth()
      if (res.code === 1000) {
        this.accountUser = res.data
      }
    },
    // 显示发布弹窗  设置登录拦截
    async showRelease() {
      if (!this.alreadyLogged) {
        this.needLogin()
      } else {
        this.releaseState = true;
      }
      //	else if (!this.accountUser.phone_is_bound) {
      // 				this.$createDialog({
      // 					type: 'confirm',
      // 					title: '请绑定手机号',
      // 					content: '根据国家相关法律规定，发表内容需绑定手机号',
      // 					confirmBtn: {
      // 						text: '去绑定',
      // 						active: true,
      // 						disabled: false,
      // 						href: 'javascript:;'
      // 					},
      // 					cancelBtn: {
      // 						text: '我再想想',
      // 						active: false,
      // 						disabled: false,
      // 						href: 'javascript:;'
      // 					},
      // 					onConfirm: () => {
      // 						this.$router.push('/account/alter_phone')
      // 					},
      // 					onCancel: async () => {
      //
      // 					}
      // 				}).show()
      // 			}
    },
    // 点击分享
    async shareArticle() {
      this.shareWxState = true
      let {id, user, topic} = this.communityData
      let res = await this.$api.bbs.shareArticle(id, {
        to_cv_account_id: user.id,
        platform: this.isEnv
      })
      if (res.code === 1000) {
        this.communityData.share_count += 1
        this.$db.ls.set('_share_count', {id: id, count: this.communityData.share_count})
      }
    },
    // 点赞和取消点赞
    async likeArticle() {
      if (!this.alreadyLogged) {
        this.needLogin()
      } else {
        let {my_status, id, user, topic} = this.communityData
        let res = await this.$api.bbs.updateArticleLike(id, {
          is_like: !my_status.has_liked,
          to_cv_account_id: user.id,
          platform: this.isEnv
        })
        if (res.code === 1000) {
          if (my_status.has_liked) {
            this.showToast(topic.id == 81 ? '经验 -1' : '已取消点赞', 1500);
          } else {
            this.showToast(topic.id == 81 ? '经验 +1' : '已点赞', 1500);
          }
          my_status.has_liked = !my_status.has_liked
          my_status.has_liked ? this.communityData.like_count += 1 : this.communityData.like_count -= 1
          // this._setStorage('session','_is_liked',JSON.stringify({has_liked:my_status.has_liked,id:id}));
          this.$db.ls.set('_is_liked', {has_liked: my_status.has_liked, id: id})
          this._synchronizeStateForList(id, 'like_count', this.communityData.like_count, 'has_liked', my_status.has_liked)
        }
      }
    },
    // 收藏和取消收藏
    async collectArticle() {
      if (!this.alreadyLogged) {
        this.needLogin()
      } else {
        let {my_status, id, user} = this.communityData
        let res = await this.$api.bbs.updateArticleCollect(id, {
          is_collect: !my_status.has_collected,
          to_cv_account_id: user.id,
          platform: this.isEnv
        })
        if (res.code === 1000) {
          if (my_status.has_collected) {
            this.showToast('已取消收藏', 1500);
          } else {
            this.showToast('已收藏', 1500);
          }
          my_status.has_collected = !my_status.has_collected
          my_status.has_collected ? this.communityData.collect_count += 1 : this.communityData.collect_count -= 1
          // this._setStorage('session','_is_collected',JSON.stringify({has_collected:my_status.has_collected,id:id}));
          this.$db.ls.set('_is_collected', {has_collected: my_status.has_collected, id: id})
          this._synchronizeStateForList(id, 'collect_count', this.communityData.collect_count, 'has_collected', my_status.has_collected)
        }
      }
    },
    //判断是不是作者
    isAuthor(author, operationComment) {
      let isAuthor = false
      if (author) {
        if (author.id != null) {
          if (author.id == operationComment.id) {
            isAuthor = true
          }
        } else {
          if (author.username == operationComment.username && author.avatar_url == operationComment.avatar_url) {
            isAuthor = true
          }
        }
      }

      return isAuthor
    },

  }
}
